import React, { useMemo, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { resetPassword } from '../api/auth';
import styles from './LoginPage.module.css';

const ResetPasswordPage = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  const email = useMemo(() => params.get('email') || '', [params]);
  const token = useMemo(() => params.get('token') || '', [params]);

  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setError('');
    setSuccess('');

    if (!token || !email) {
      setError('無効なリンクです。再度パスワード再設定をお試しください。');
      return;
    }

    if (password.length < 8) {
      setError('パスワードは8文字以上で入力してください。');
      return;
    }

    if (password !== passwordConfirmation) {
      setError('パスワード確認が一致しません。');
      return;
    }

    setLoading(true);
    try {
      const res = await resetPassword({
        token,
        email,
        password,
        password_confirmation: passwordConfirmation,
      });

      setSuccess(res?.message || 'パスワードを更新しました。');
      setTimeout(() => navigate('/login', { replace: true }), 1200);
    } catch (err) {
      const data = err?.response?.data;
      if (data?.errors) {
        const messages = Object.values(data.errors).flat();
        setError(messages.join(' / '));
      } else {
        setError(data?.message || 'パスワードの更新に失敗しました。');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>新しいパスワードを設定</h2>

      {error && <p className={styles.error}>{error}</p>}
      {success && <p>{success}</p>}

      <label htmlFor="reset-email" style={{ display: 'block', marginBottom: 4 }}>メールアドレス</label>
      <input
        id="reset-email"
        type="email"
        value={email}
        readOnly
        style={{ display: 'block', marginBottom: '10px' }}
      />

      <label htmlFor="reset-password" style={{ display: 'block', marginBottom: 4 }}>新しいパスワード</label>
      <input
        id="reset-password"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="新しいパスワード"
        autoComplete="new-password"
        style={{ display: 'block', marginBottom: '10px' }}
      />

      <label htmlFor="reset-password-confirmation" style={{ display: 'block', marginBottom: 4 }}>確認用パスワード</label>
      <input
        id="reset-password-confirmation"
        type="password"
        value={passwordConfirmation}
        onChange={(e) => setPasswordConfirmation(e.target.value)}
        placeholder="確認用パスワード"
        autoComplete="new-password"
        style={{ display: 'block', marginBottom: '10px' }}
      />

      <button className={styles.loginButton} onClick={handleSubmit} disabled={loading}>
        {loading ? '更新中...' : 'パスワードを更新'}
      </button>

      <div className={styles.linkRow}>
        <Link to="/login" style={{ color: 'blue', textDecoration: 'underline' }}>
          ログインへ戻る
        </Link>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
